import React, { FC } from 'react';

import Image from 'next/image';

import { TypeShipmentList } from '@/core/generated-types';

import useLocale from '@/hooks/useLocale';

import { formatMoney } from '@/utils/helpers';

export interface ProductShipmentListProps {
  shipmentList: TypeShipmentList;
  priceLabel: string;
  itemLabel: string;
}

const ProductShipmentList: FC<ProductShipmentListProps> = ({
  shipmentList,
  priceLabel,
  itemLabel,
}) => {
  const locale = useLocale();

  const {
    listTitle,
    listSubTitle,
    subscriptionDeliveryPrice,
    shipments,
    firstItemPill,
  } = shipmentList.fields;

  return (
    <>
      <div className="grid grid-cols-[1fr_auto] gap-x-2">
        <div>
          <p className="font-bold text-lg" data-testid="product-title">
            {listTitle}
          </p>
          <p className="text-sm lg:text-lg" data-testid="product-description">
            {listSubTitle}
          </p>
        </div>
        <div className="text-right">
          <p
            className="text-lg font-bold"
            data-testid="subscription-delivery-price"
          >
            {formatMoney(Number(subscriptionDeliveryPrice), locale, true)}
          </p>
          <p
            className="text-base lg:text-lg"
            data-testid="subscription-delivery-price-label"
          >
            {priceLabel}
          </p>
        </div>
      </div>
      <div className="grid gap-y-6 lg:gap-y-3">
        {shipments.map((shipment, i) => (
          <div
            key={shipment.sys.id}
            className="grid grid-cols-[90px_1fr] gap-x-2"
          >
            <Image
              className="bg-blue-light"
              src={`https:${shipment.fields.image.fields.file.url}`}
              alt={shipment.fields.image.fields.title}
              height={90}
              width={90}
            />
            <div className="grid gap-y-1">
              {i === 0 && (
                <span
                  className="justify-self-start border-2 border-blue-deep rounded-3xl px-4 py-1 text-xs text-blue-deep font-bold"
                  data-testid="first-item-pill"
                >
                  {firstItemPill}
                </span>
              )}
              <div>
                <p
                  className="font-bradford text-xs lg:text-sm font-medium"
                  data-testid="item-label"
                >
                  {itemLabel} {i + 1}
                </p>
                <p
                  className="text-sm lg:text-base font-bold"
                  data-testid="shipment-title"
                >
                  {shipment.fields.title}
                </p>
                <p
                  className="text-xs lg:text-sm"
                  data-testid="shipment-description"
                >
                  {shipment.fields.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductShipmentList;
